import React from "react";
import { AccessGroupSelector } from "../../../../components/AccessGroupSelector/AccessGroupSelector";
import ToggleButton from "../../../../components/ToggleButton/ToggleButton";
import FormAccessGroups from "../../../AccessGroups/FormAccessGroups/FormAccessGroups";
import "./TabCondoUsersAccessGroups.css";

const TabCondoUsersAccessGroups = (props) => {
	const [useAccessGroups, setUseAccessGroups] = React.useState(
		props.tempGroup?.useAccessGroupsEnabled ?? false
	);
	// isTempUser é controlado pelo pai (FormCondoUsers) para sobreviver à troca de abas
	const isTempUser = props.isTempUser ?? false;

	React.useEffect(() => {
		setUseAccessGroups(props.tempGroup?.useAccessGroupsEnabled ?? false);
	}, [props.tempGroup?.useAccessGroupsEnabled]);

	const handleSelectedGroups = (groups) => {
		props.handleChangeGroups(groups);
	};

	return (
		<div className={props.className}>
			<div style={{ display: "flex", justifyContent: "center", marginBottom: "35px" }}>
				<div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
					<ToggleButton
						label="Fornecer acesso temporário"
						name="isTempUser"
						id="isTempUser"
						defaultChecked={isTempUser}
						onChange={({ target }) => props.onIsTempUserChange?.(target.checked)}
						required={false}
						disabled={props.type === "consulta"}
					/>
				</div>
			</div>
			<div style={{ display: "flex", justifyContent: "center", alignItems: "start" }}>
				{isTempUser && (
					<div style={{ width: useAccessGroups ? "65%" : "100%" }}>
						<FormAccessGroups
							isTemp={true}
							tabChanged={props.tabChanged}
							handleNewTempGroup={(group) => handleSelectedGroups(group)}
							accessGroup={props.tempGroup ?? undefined}
							onTempGroupChange={(_tempGroup) => {
								props.onTempGroupChange(_tempGroup);
								setUseAccessGroups(_tempGroup.useAccessGroupsEnabled || false);
							}}
						/>
					</div>
				)}
				{(!isTempUser || useAccessGroups) && (
					<AccessGroupSelector
						groups={props.groups ?? []}
						onChange={props.handleChangeGroups}
						disabled={props.type === "consulta"}
						className={`tab-access-groups ${isTempUser ? "pl-5!" : ""}`}
						style={{ width: "35%" }}
					/>
				)}
			</div>
		</div>
	);
};

export default TabCondoUsersAccessGroups;
